<template>
	<keep-alive>
	<div class="news">
		
		<!-- 头部 -->
		<zmlmenupage cn-name='资讯中心' en-name='News Center'></zmlmenupage>
		
		<zmlpagebanner
		banner-img='static/img/newsBanner.jpg' 
		banner-text='海量货盘，找货不难！' 
		cn-name='资讯中心' 
		en-name='News Center'>
		</zmlpagebanner>

		<!-- 导航 -->
		<div class="news-nav">
			<div class="infoTotal news-nav-info">
				<ul class="flex">
					<li v-for="(item,index) in newsNav" :key="item.id" :class="{select:num==index}" @click="getnewslist(item.id,index)">
						{{item.name}}
					</li>
				</ul>
			</div>
		</div>
		<!-- 新闻列表 -->
		<div class="news-list">
			<div class="info news-list-info">
				<div class="news-list-box flex">
					<router-link class="news-item" v-for="(item) in newslist" :key="item.id" :to="{path:'newsdetail',query:{id:item.id}}">
						<div class="news-ite-img">
							<img :src="item.url" alt="" style="height:100%">
						</div>
						<div class="news-item-text">
							<p>{{item.title}}</p>
							<p>{{item.create_time}}</p>
						</div>
					</router-link>
				</div>
				<!-- 分页 -->
				<!-- <div class="news-page flexCenter">
					<span class="news-page-button flexCenter" @click="prevPage"><i class="el-icon-arrow-left"></i></span>
					<span class="news-page-num flexCenter" v-for="(item,index) in pagelist" :key="index" :class="{page_select:(index+1)==page}" @click="pagenumList(index)">
						{{index+1}}
					</span>
					<span class="news-page-button flexCenter" @click="nextPage"><i class="el-icon-arrow-right"></i></span>
				</div> -->
				<div class="paging">
				<el-pagination background layout="prev, pager, next" :current-page="page" :page-size="pageSize" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
				</div>
			</div>
		</div>
		
		<!-- 移动端可见 -->
		<div class="iphone-news">
			<div class="iphone-news-nav">
				<swiper ref="mySwiper" :options="swiperOptions">
					<swiper-slide v-for="(item,index) in newsNav" :key="item.id" :data-id="item.id" :class="{select:num==index}">
						{{item.name}}
					</swiper-slide>
				</swiper>
				<div class="swiper-button-prev news-prev"><i class="el-icon-arrow-left"></i></div>
				<div class="swiper-button-next news-next"><i class="el-icon-arrow-right"></i></div>
			</div>
			<div class="phone-news-list">
				<router-link class="phone-news-item flexItems" :to="{path:'newsdetail',query:{id:item.id}}" v-for="(item,index) in newslist" :key="index">
					<div class="phone-news-item-img">
						<img :src="item.url" alt="">
					</div>
					<div class="phone-news-item-text">
						{{item.title}}
					</div>
				</router-link>
			</div>
			<router-link to="" @click.native="findmore" class="findMore">查看更多</router-link>
		</div>
		<gototop></gototop>
	</div>
	</keep-alive>
</template>
<script>
	let vm = null;
	import {getNewsList,getTypeNewsList} from '@/api/api'
	export default{
		name:'news',
		data(){
		  return{
			swiperOptions: {
				slidesPerView : 4, 
				navigation: {
					nextEl: '.news-next',
					prevEl: '.news-prev',
				},
				observer: true,
				observerParents: true,
				on:{
					tap:function(event){
						vm.getnewslist(event.target.dataset.id,this.clickedIndex);
					}
				}
			},
			newsNav:[],
			newsNavId:'', //默认显示的新闻类别
			num:0,
			newslist:[],
			page: 1, //默认第一页
			pagelist: null,
			total: 0,
			pageSize: 8
		  }
		},
		methods:{
			// 点击导航 改变类别， 获取对应新闻列表
			getnewslist(id,index){
				this.page = 1; //每次选择类别的时候，要重置为第一页
				this.num = index;
				this.newsNavId = id;
				this._getTypeNewsList(id,this.page);
			},
			// 获取新闻类别和默认第一个类别的id
			_getnewslist(){
				getNewsList().then((res)=>{
					console.log(res)
					this.newsNav = res.data.data.menu
					this.newsNavId = res.data.data.menu[0].id
				}).catch((res)=>{
					
				})
			},
			// 获取新闻列表，（根据类别和页码获取  默认一页显示6个）
			_getTypeNewsList(id,page){
				getTypeNewsList(id,page).then((res)=>{
					// console.log(res.data.data)
					this.newslist = res.data.data.list
					this.pagelist = Math.ceil(res.data.data.total/6)
					this.total = Math.ceil(res.data.data.total)
				}).catch((err)=>{
					
				})
			},
			// 点击页码获取新闻列表
			pagenumList(index){
				this.page = index + 1;  //获取点击的页码 因为传过来的是下标值
				this._getTypeNewsList(this.newsNavId,this.page);
			},
			
			// 上一页
			prevPage(){
				if(this.page == 1){
					this.$message({
					  message: '已经是第一页了',
					  type: 'warning',
					  duration: 1000
					});
				}else{
					this.page--;
					this._getTypeNewsList(this.newsNavId,this.page);
				}
			},
			// 下一页
			nextPage(){
				if(this.page == this.pagelist){
					this.$message({
					  message: '已经是最后一页了',
					  type: 'warning',
					  duration: 1000
					});
				}else{
					this.page++;
					this._getTypeNewsList(this.newsNavId,this.page);
				}
			},
			
			 /**
     * 切换每页加载的数量;
     */
    handleSizeChange (pageSize) {
	  this.pageSize = pageSize;
	  this._getTypeNewsList(this.newsNavId,this.pageSize)
    },
    /**
     * 切换页码;
     */
    handleCurrentChange (page) {
      this.page = page;
	  this._getTypeNewsList(this.newsNavId,page)
    },
			
			// 移动端查看更多
			findmore(){
				this.page ++;
				getTypeNewsList(this.newsNavId,this.page).then((res)=>{
					// console.log(res.data.data)
					if(res.data.data.list == ''){
						this.$message({
						  message: '没有更多了',
						  type: 'warning',
						  duration: 1000
						});
					}else{
						res.data.data.list.forEach(item=>{
							this.newslist.push(item)
						})
					}
				}).catch((err)=>{
					
				})
			},
			
		},
		mounted() {
			this._getnewslist();
			setTimeout(()=>{
				this._getTypeNewsList(this.newsNavId,this.page);
			},500)
			
		},
		created() {
			vm = this;
		},
		computed:{
			swiper(){
			  return this.$refs.mySwiper.$swiper;
			}
		},
	}
</script>
<style scoped="scoped">
.info{
	width: 1580px;
	height: 100%;
	margin: auto;
}
.infoTotal{
	width: 1400px;
	height: 100%;
	margin: auto;
}
.news-nav{
	width: 100%;
	height: auto;
	border-bottom: 1px solid #EDEDED;
	padding-top: 86px;
}
.news-nav-info ul li{
	line-height: 42px;
	margin-right: 111px;
	font-size: 18px;
	color: #787878;
	cursor: pointer;
}
.select{
	font-weight: bold;
	color: #343434;
	position: relative;
}
.select::before{
	position: absolute;
	content: "";
	width:32px;
	height:3px;
	background:rgba(35,137,244,1);
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
}

.news-list{
	padding: 66px 0 100px 0;
}
.news-list-box{
	flex-wrap: wrap;
}
.news-item{
	display: block;
	width: 314.2px;
	min-height: 360px;
	overflow: hidden;
	margin-bottom: 40px;
	margin-left: 70px;
	transition: .3s;
}
.news-item:nth-of-type(3n-0){
	/* margin-left: 0; */margin-left: 70px;
}
.news-item-text{
	padding: 25px;
}
.news-item-text p:nth-of-type(1){
	font-size: 16px;
	color: #282828;
}
.news-item-text p:nth-of-type(2){
	font-size: 13px;
	color: #999;
	margin-top: 10px;
}
.news-item:hover{
	transform: translateY(-40px);
}
.news-item:hover .news-ite-img{
	box-shadow: 0 10px 20px 0 rgba(0,0,0,.1);
}
.news-ite-img{
	width: 100%;
	height: 155px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	transition: .3s;
}
.news-ite-img img{
	width: 100%;
}

.news-page{
	width: 300px;
}

.news-page span{
	display: flex;
	width: 40px;
	height: 40px;
	font-size: 18px;
	color: #ADADB0;
}
.news-page .news-page-button{
	width: 40px;
	height: 40px;
	background-color: #ECF1F8;
	transition: .3s;
	cursor: pointer;
	font-size: 20px;
	color: #ADADB0;
	margin: 0px 20px;
}
.news-page .news-page-button:hover{
	background-color: #127BFD;
	color: #fff;
}
.news-page-num{
	margin: 0px 10px;
	cursor: pointer;
}
.news-page .page_select{
	font-weight: bold;
	font-size: 20px;
}

.iphone-news{
	display: none;
}
@media only screen and (max-width: 750px){
	.news{
		height: 100%;
	}
	.news-nav{
		padding-top: 0;
	}
	.news-nav,.news-list{
		display: none;
	}
	.iphone-news{
		display: block;
		width: 100%;
		height: calc(100% - 84px - 36px);
		padding: 0 23px;
		border-top: 10px solid #F4F4F6;
		overflow-y: auto;
	}
	.iphone-news-nav{
		position: relative;
	}
	.phone-news-list{
		padding: 30px 0;
	}
	.phone-news-item{
		width: 100%;
		height: auto;
		margin-bottom: 10px;
		color: #282828;
	}
	.phone-news-item-img{
		width: 110px;
		height: 66px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.phone-news-item-img img{
		width: 100%;
	}
	.phone-news-item-text{
		font-size: 16px;
		padding-left: 10px;
		flex: 1;
		line-height: 22px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient:vertical;
		-webkit-line-clamp:2;
	}
	.swiper-slide{
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		color: #787878;
	}
	>>>.swiper-button-prev,
	>>>.swiper-button-next{
		background-image: url();
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.swiper-button-prev:after,
	.swiper-button-next:after{
		font-size: 16px;
		opacity: 1;
		color: #dedede;
		font-weight: bold;
	}
	.swiper-button-prev.swiper-button-disabled, 
	.swiper-button-next.swiper-button-disabled{
		opacity: 1;
	}
	.news-prev{
		font-size: 16px;
		left: -20px;
	}
	.news-next{
		right: -20px;
	}
}
.paging{
	width: 100%;
	text-align: center;
}
.paging >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #FFF;
	color: #adadb0;
	font-size: 20px
}
.paging >>> .el-pager li{
	background-color: #FFF;
	color: #adadb0;
	font-size: 18px;
	width: 40px;
	line-height: 40px;
}
.paging >>> .el-pagination button, .el-pagination span:not([class*=suffix]){
	height: 40px;
	line-height: 40px;
}
.paging >>> .el-pagination .btn-prev{
	width: 40px;
}
.paging >>> .el-pagination .btn-prev:hover{
	background-color: #127bfd;
	color: rgb(250, 250, 250);
}
.paging >>> .el-pagination .btn-next{
	width: 40px;
}
.paging >>> .el-pagination .btn-next:hover{
	background-color: #127bfd;
	color: rgb(250, 250, 250);
}
.paging >>> .el-pagination.is-background .el-pager li{
	background-color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/news.vue